import React from 'react'
import { withJsonFormsLabelProps } from '@jsonforms/react'
import { Typography } from '@mui/material'

const Subtitle = ({ uischema, visible }) => {
    if (!visible) {
        return null
    }
    return (
        <Typography
            variant={'subtitle2'}
            sx={{
                color: 'rgb(134, 132, 140)',
                margin: '5px 0 25px 0',
            }}
        >
            {' '}
            {uischema.text}{' '}
        </Typography>
    )
}

export default withJsonFormsLabelProps(Subtitle)
